import { NumberFormat } from '../../../formatters/utils/NumberFormat'
import { LocaleIdentifier } from '../../../types/localeIdentifier'
import { isEmptyValue } from './isEmptyValue'
import { limitValue } from './limitValue'

interface GetFormattedValueOptions {
  value: string | number | undefined
  max?: number
  min?: number
  isDisplayValueFormat?: boolean
  isFallbackToZero?: boolean
  locale?: LocaleIdentifier
}

export interface GetFormattedValueResponse {
  value: string
  hasValueBeenLimited: boolean
}

export const getFormattedValue = ({
  value,
  isDisplayValueFormat,
  isFallbackToZero,
  max,
  min,
  locale = 'en_US',
}: GetFormattedValueOptions): GetFormattedValueResponse => {
  const valueParsed = typeof value === 'number' ? value : NumberFormat.parseToNumber(value, locale)
  const { valueLimited, hasValueBeenLimited } = limitValue({ value: valueParsed, min, max })
  let formattedValue = !isEmptyValue(value) ? String(valueLimited) : ''

  const shouldFallbackToZero = !formattedValue && isFallbackToZero

  if (shouldFallbackToZero) {
    formattedValue = '0'
  }

  // We want to format the value only when:
  // 1. isDisplayValueFormat is true (duh...)
  //  AND
  // 2. We have a value that's going to be formatted, so:
  //    a) isFallbackToZero is set (we still want to format the zero that will pop in)
  //     OR
  //    b) the value is not empty, so there's actually sth to format
  const shouldFormatValue = isDisplayValueFormat && (isFallbackToZero || !isEmptyValue(value))

  formattedValue = shouldFormatValue
    ? NumberFormat.getFormattedNumber(valueLimited || 0, locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : formattedValue

  return { value: formattedValue, hasValueBeenLimited }
}
